import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import Admin from "./pages/Admin";
import FrontDesk from "./pages/FrontDesk";
import FrontDesk2 from "./pages/main/FrontDesk2";
import FrontDeskNewDataData from "./pages/main/FrontDeskNewDataData";
import BackDesk from "./pages/BackDesk";
import AllPages from "./pages/AllPages";
import Login from "./pages/Login";
import Mobile from "./pages/Mobile";
import AddNewsAtBottom from "./pages/AddNewsAtBottom";
import ProtectedRoute from "./components/ProtectedRoute";
import CombinedPage from "./pages/CombinedPage.jsx";
import Rotate90 from "./pages/Rotate90.jsx";
import Rotate270 from "./pages/Rotate270.jsx";
// import NamesRamadan from "./pages/NamesRamadan.jsx";
import RamadanNamesView from "./pages/RamadanNamesView.jsx";
import AddNamesRamadan from "./pages/AddNamesRamadan.jsx";
import SlideShow from "./pages/SlideShow.jsx";
import FetchPrayerTimes from "./pages/FetchPrayerTimes.jsx";
// import AddPage from "./pages/AddPage.jsx";
import AdminPage from "./pages/AdminPage.jsx";
import MonthlyViewPage from "./pages/MonthlyViewPage.jsx";
import EditPage from "./pages/EditPage.jsx";
import MonthlyWeeklyViewPage from "./pages/MonthlyWeeklyViewPage.jsx";
import AnalyticsPage from "./pages/AnalyticsPage.jsx";
import TransactionWithPicture from "./pages/TransactionWithPicture.jsx";
import Countdown3DCopy from "../src/pages/Countdown3DCopy.jsx";

export default function App() {
  return (
    <div className="container">
      {/* <nav className="nav">
        <Link to="/admin">Admin</Link>
        <Link to="/frontDesk">FrontDesk</Link>
        <Link to="/backDesk">BackDesk</Link>
      </nav> */}

      <Routes>
        <Route path="/" element={<FrontDesk />} />
        <Route path="/frontDesk" element={<FrontDesk />} />
        <Route path="/frontDesk2" element={<FrontDesk2 />} />
        <Route path="/mic/mobile" element={<Mobile />} />
        <Route path="/allPages" element={<AllPages />} />
        <Route path="/rotate90" element={<Rotate90 />} />
        <Route path="/mic/270" element={<Rotate270 />} />
        <Route path="/mic/3d" element={<Countdown3DCopy />} />
        {/* <Route path="/namesRamadan" element={<NamesRamadan />} /> */}
        <Route path="/ramadanNamesView" element={<RamadanNamesView />} />
        <Route path="/ramadanDailySlideShow" element={<SlideShow />} />
        {/* <Route path="/addNamesRamadan" element={<AddNamesRamadan />} /> */}
        {/* <Route path="/mic/forAll/mehdi/combined" element={<CombinedPage />} /> */}
        {/* <Route path="/add" element={<AddPage />} /> */}
        <Route path="/mic/mainTV" element={<FrontDeskNewDataData />} />
        <Route path="/mic/out" element={<BackDesk />} />
        <Route path="/login" element={<Login />} />
        {/* <Route path="/addNewsAtBottom" element={<AddNewsAtBottom />} /> */}

        <Route path="/transactionAdmin" element={<AdminPage />} />
        <Route path="/transactionEdit" element={<EditPage />} />
        <Route path="/transactionView" element={<MonthlyViewPage />} />
        <Route
          path="/transactionWithPicture"
          element={<TransactionWithPicture />}
        />
        <Route
          path="/transactionMonthlyWeeklyViewPage"
          element={<MonthlyWeeklyViewPage />}
        />
        <Route path="/transactionAnalytics" element={<AnalyticsPage />} />

        <Route
          path="/mic/forAll/mehdi/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mic/forAll/mehdi/combined"
          element={
            <ProtectedRoute>
              <CombinedPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mic/forAll/mehdi/AddNewsAtBottom"
          element={
            <ProtectedRoute>
              <AddNewsAtBottom />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mic/forAll/mehdi/api"
          element={
            <ProtectedRoute>
              <FetchPrayerTimes />
            </ProtectedRoute>
          }
        />

        <Route
          path="/mic/forAll/mehdi/addNamesRamadan"
          element={
            <ProtectedRoute>
              <AddNamesRamadan />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}
